//GET_ALL_PERFORMANCE
export const GET_ALL_PERFORMANCE_REQUEST = "GET_ALL_PERFORMANCE_REQUEST";
export const GET_ALL_PERFORMANCE_SUCCESS = "GET_ALL_PERFORMANCE_SUCCESS";
export const GET_ALL_PERFORMANCE_FAIL = "GET_ALL_PERFORMANCE_FAIL";

//CREATE_PERFORMANCE
export const CREATE_PERFORMANCE_REQUEST = "CREATE_PERFORMANCE_REQUEST";
export const CREATE_PERFORMANCE_SUCCESS = "CREATE_PERFORMANCE_SUCCESS";
export const CREATE_PERFORMANCE_FAIL = "CREATE_PERFORMANCE_FAIL";

//UPDATE_PERFORMANCE
export const UPDATE_PERFORMANCE_REQUEST = "UPDATE_PERFORMANCE_REQUEST";
export const UPDATE_PERFORMANCE_SUCCESS = "UPDATE_PERFORMANCE_SUCCESS";
export const UPDATE_PERFORMANCE_FAIL = "UPDATE_PERFORMANCE_FAIL";

//ARCHIVE_PERFORMANCE
export const ARCHIVE_PERFORMANCE_REQUEST = "ARCHIVE_PERFORMANCE_REQUEST";
export const ARCHIVE_PERFORMANCE_SUCCESS = "ARCHIVE_PERFORMANCE_SUCCESS";
export const ARCHIVE_PERFORMANCE_FAIL = "ARCHIVE_PERFORMANCE_FAIL";

//ADD_PERFORMANCE_COMMENT
export const ADD_PERFORMANCE_COMMENT_REQUEST =
  "ADD_PERFORMANCE_COMMENT_REQUEST";
export const ADD_PERFORMANCE_COMMENT_SUCCESS =
  "ADD_PERFORMANCE_COMMENT_SUCCESS";
export const ADD_PERFORMANCE_COMMENT_FAIL = "ADD_PERFORMANCE_COMMENT_FAIL";

//UPDATE_COMMENT_PERFORMANCE
export const UPDATE_PERFORMANCE_COMMENT_REQUEST =
  "UPDATE_PERFORMANCE_COMMENT_REQUEST";
export const UPDATE_PERFORMANCE_COMMENT_SUCCESS =
  "UPDATE_PERFORMANCE_COMMENT_SUCCESS";
export const UPDATE_PERFORMANCE_COMMENT_FAIL =
  "UPDATE_PERFORMANCE_COMMENT_FAIL";

//GET_COMMENTS_FOR_ONE_PERFORMANCE
export const GET_COMMENTS_FOR_ONE_PERFORMANCE_REQUEST =
  "GET_COMMENTS_FOR_ONE_PERFORMANCE_REQUEST";
export const GET_COMMENTS_FOR_ONE_PERFORMANCE_SUCCESS =
  "GET_COMMENTS_FOR_ONE_PERFORMANCE_SUCCESS";
export const GET_COMMENTS_FOR_ONE_PERFORMANCE_FAIL =
  "GET_COMMENTS_FOR_ONE_PERFORMANCE_FAIL";

//DELETE_PERFORMANCE_COMMENT
export const DELETE_PERFORMANCE_COMMENT_REQUEST =
  "DELETE_PERFORMANCE_COMMENT_REQUEST";
export const DELETE_PERFORMANCE_COMMENT_SUCCESS =
  "DELETE_PERFORMANCE_COMMENT_SUCCESS";
export const DELETE_PERFORMANCE_COMMENT_FAIL =
  "DELETE_PERFORMANCE_COMMENT_FAIL";
